var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3749 27.1886C12.5445 27.1886 10.2499 29.471 10.2499 32.2865C10.2499 33.225 11.0148 33.9858 11.9583 33.9858H29.0416C29.9851 33.9858 30.7499 33.225 30.7499 32.2865C30.7499 29.471 28.4554 27.1886 25.6249 27.1886H15.3749ZM6.83325 32.2865C6.83325 27.594 10.6575 23.79 15.3749 23.79H25.6249C30.3423 23.79 34.1666 27.594 34.1666 32.2865C34.1666 35.102 31.872 37.3844 29.0416 37.3844H11.9583C9.12779 37.3844 6.83325 35.102 6.83325 32.2865Z",
    fill: "#ffbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4999 6.79727C17.6695 6.79727 15.3749 9.07967 15.3749 11.8952C15.3749 14.7106 17.6695 16.993 20.4999 16.993C23.3304 16.993 25.6249 14.7106 25.6249 11.8952C25.6249 9.07967 23.3304 6.79727 20.4999 6.79727ZM11.9583 11.8952C11.9583 7.20268 15.7825 3.39868 20.4999 3.39868C25.2174 3.39868 29.0416 7.20268 29.0416 11.8952C29.0416 16.5876 25.2174 20.3916 20.4999 20.3916C15.7825 20.3916 11.9583 16.5876 11.9583 11.8952Z",
    fill: "#ffbb00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorPreview);
export default __webpack_public_path__ + "static/media/doctor-preview.672a3a604c3890b134376185288d413d.svg";
export { ForwardRef as ReactComponent };